import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideState, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { routes } from './app.routes';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { requestCountInterceptor } from './shared/interceptors/request-count.interceptor';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideNativeDateAdapter } from '@angular/material/core';
import { LogsActions } from './pages/logs/store/actions';
import { authInterceptor } from './shared/interceptors/auth-interceptor.interceptor';
import { commonFeature } from './shared/store/reducers';
import { CommonEffects } from './shared/store/effects';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptors([requestCountInterceptor, authInterceptor])
    ),
    provideStore(),
    provideEffects(),
    provideState(commonFeature),
    provideEffects(CommonEffects),
    provideCharts(withDefaultRegisterables()),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true, // If set to true, the connection is established within the Angular zone
      actionSanitizer: (action) =>
        action.type == LogsActions.getLogsSuccess.type
          ? { ...action, logs: [] }
          : action,
      stateSanitizer: (state) => (state.logs ? { ...state, logs: {} } : state),
    }),
    importProvidersFrom(SsrCookieService),
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000 } },
    provideNativeDateAdapter(),
  ],
};
